import LegalPage from "@/pages/LegalPage";

export default function TermsOfServicePage() {
  return (
    <LegalPage
      title={<>Terms of <em>Service.</em></>}
      subtitle="Please read these Terms of Service carefully before using our website or placing an order with Utsah."
      lastUpdated="29 July 2026"
      metaTitle="Terms of Service | Utsah"
      metaDescription="Read the Terms of Service governing the use of the Utsah website, products and services."
    >
      <h2>1. Acceptance of Terms</h2>
      <p>These Terms of Service ("Terms") govern your access to and use of the Utsah website and any products or services offered by Kiran Ventures under the Utsah brand.</p>
      <p>By accessing this website, requesting a quotation or placing an order with Utsah, you agree to be bound by these Terms.</p>
      <p>If you do not agree with these Terms, please refrain from using our website or services.</p>

      <h2>2. Company Information</h2>
      <p>Utsah is a brand operated by:</p>
      <p>
        Kiran Ventures<br />
        54 Vinay Nagar<br />
        Kesar Bagh Road<br />
        Indore, Madhya Pradesh 452009<br />
        India
      </p>
      <p>Legal enquiries: <a href="mailto:atishaya@utsahgifting.com">atishaya@utsahgifting.com</a></p>
      <p>Customer Support: <a href="mailto:pragati@utsahgifting.com">pragati@utsahgifting.com</a></p>
      <p>Phone: +91 90988 80482</p>

      <h2>3. Website Use</h2>
      <p>You agree to use this website only for lawful purposes.</p>
      <p>You must not:</p>
      <ul>
        <li>misuse the website</li>
        <li>attempt unauthorised access</li>
        <li>distribute malicious software</li>
        <li>copy website content without permission</li>
        <li>interfere with website functionality</li>
      </ul>

      <h2>4. Quotations &amp; Orders</h2>
      <p>All quotations provided by Utsah are valid only for the period specified within the quotation.</p>
      <p>Submission of a Purchase Order (PO), email confirmation or verbal confirmation alone does not constitute an accepted order.</p>
      <p>An order is considered confirmed only after the required advance payment has been successfully received.</p>
      <p>Utsah reserves the right to accept or decline any order at its sole discretion.</p>

      <h2>5. Advance Payment</h2>
      <p>Unless otherwise agreed in writing:</p>
      <ul>
        <li>50% advance payment is required before production or procurement begins.</li>
        <li>The remaining 50% balance must be paid before dispatch.</li>
      </ul>
      <p>Production will not begin until the required advance payment has been received.</p>

      <h2>6. Customisation</h2>
      <p>Custom branding and personalised products require a minimum order quantity of 50 units, unless otherwise agreed in writing.</p>
      <p>Customers are responsible for reviewing and approving all artwork, logos, spellings, colours and branding proofs before production.</p>
      <p>Once artwork has been approved, Utsah shall not be responsible for errors contained within the approved proof.</p>

      <h2>7. Pricing &amp; Taxes</h2>
      <p>All prices are subject to applicable taxes.</p>
      <p>Unless otherwise stated, GST at the prevailing rate (currently 18%) will be charged.</p>

      <h2>8. Payments</h2>
      <p>Accepted payment methods include:</p>
      <ul>
        <li>NEFT</li>
        <li>Bank Transfer</li>
        <li>UPI</li>
        <li>Cheque</li>
      </ul>

      <h2>9. Shipping &amp; Delivery</h2>
      <p>Currently, Utsah delivers within India only.</p>
      <p>Risk of loss or damage passes to the customer once the shipment has been handed over to the shipping partner or transporter.</p>
      <p>While Utsah will reasonably assist in resolving shipment-related issues, we shall not be responsible for delays, damage or loss occurring after dispatch.</p>

      <h2>10. Cancellation Policy</h2>
      <p>Customers may request cancellation before production begins.</p>
      <p>Once production, procurement, branding or customisation has commenced, cancellations may be accepted at Utsah's discretion; however, the advance payment shall remain non-refundable.</p>

      <h2>11. Product Variations</h2>
      <p>Due to the nature of handcrafted products, natural materials, printing processes and product sourcing, minor variations in colour, texture, grain, finish, dimensions or packaging may occur.</p>
      <p>Such variations shall not be considered defects.</p>

      <h2>12. Exclusive Partner Benefit Program</h2>
      <p>Eligible hampers may include access to the Exclusive Partner Benefit Program.</p>
      <p>The programme provides access to offers made available by independent third-party brands.</p>
      <p>Participating brands, offers and benefits may change, expire or be withdrawn without prior notice.</p>
      <p>Utsah does not own or operate these third-party offers and does not guarantee the continued availability of any specific brand or promotion.</p>
      <p>Redemption of offers is subject to the respective partner's own terms and conditions.</p>
      <p>QR codes currently do not expire; however, available partner offers may change over time.</p>

      <h2>13. Green Gift Initiative</h2>
      <p>Selected hampers participate in the Green Gift Initiative.</p>
      <p>For every eligible hamper purchased, one tree is intended to be planted through our implementation partner, Grow-Trees.com, an independent social enterprise.</p>
      <p>Tree plantation services are carried out by Grow-Trees.com.</p>
      <p>Utsah facilitates participation in this initiative but is not responsible for delays, operational issues or non-performance by the third-party plantation partner.</p>

      <h2>14. Intellectual Property</h2>
      <p>All website content, branding, logos, product photography, catalogues, packaging designs and related materials remain the intellectual property of Kiran Ventures and Utsah unless otherwise stated.</p>
      <p>No content may be copied, reproduced or distributed without prior written permission.</p>

      <h2>15. Limitation of Liability</h2>
      <p>To the maximum extent permitted by applicable law, Utsah shall not be liable for indirect, incidental, consequential or special damages arising from the use of our website, products or services.</p>

      <h2>16. Governing Law</h2>
      <p>These Terms shall be governed by the laws of India.</p>
      <p>Any disputes shall be subject to the exclusive jurisdiction of the courts located in Indore, Madhya Pradesh.</p>

      <h2>17. Changes to These Terms</h2>
      <p>Utsah reserves the right to modify these Terms at any time.</p>
      <p>Updated versions will be published on this page with the revised effective date.</p>

      <h2>18. Contact Us</h2>
      <p>For any questions regarding these Terms, please contact:</p>
      <p>
        Kiran Ventures (Utsah)<br />
        Email: <a href="mailto:atishaya@utsahgifting.com">atishaya@utsahgifting.com</a><br />
        Support: <a href="mailto:pragati@utsahgifting.com">pragati@utsahgifting.com</a><br />
        Phone: +91 90988 80482
      </p>
    </LegalPage>
  );
}
